import { useMutation, useQueryClient } from "@tanstack/react-query";
import { objectQueries, updateObject } from "@entities/object";


interface IUseUpdateObject {
  projectId: string;
  objectId: string;
}

export function useUpdateObject({ projectId, objectId }: IUseUpdateObject) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateObject,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: objectQueries.getObject({ projectId, objectId }).queryKey,
      });
      // сбросить кеш всех журналов при обновлении проекта
      queryClient.invalidateQueries({
        queryKey: ["get", "/api/v1/journals/title/{titleId}"],
      });
    },
  });
}
